import "../../chunk-7QVYU63E.js";
import { z } from "zod";
const FAILED_PREPARE_CALL_ID_PREFIX = "failed-prepare-";
const WalletApiMethodSchema = z.enum([
  "wallet_prepareCalls",
  "wallet_sendPreparedCalls",
  "wallet_getCallsStatus"
]);
const WalletStatusCode = {
  PENDING: 100,
  PRECONFIRMED: 110,
  PRECONFIRMED_ONCHAIN_FAILURE: 115,
  PRECONFIRMED_PARTIAL_FAILURE: 116,
  CROSS_CHAIN_PENDING: 120,
  CONFIRMED: 200,
  OFFCHAIN_FAILURE: 400,
  CROSS_CHAIN_REFUNDED: 410,
  ONCHAIN_FAILURE: 500,
  PARTIAL_FAILURE: 600
};
const CallIdGroupStatusSchema = z.enum([
  "prepare_failed",
  "send_failed",
  "status_failed",
  "prepared",
  "sent",
  "unknown",
  // Statuses from wallet_getCallsStatus response
  "pending",
  "preconfirmed",
  "cross_chain_pending",
  "confirmed",
  "offchain_failure",
  "cross_chain_refunded",
  "onchain_failure",
  "partial_failure"
]);
const AIErrorTypeSchema = z.enum([
  "validation",
  "sponsorship",
  "session_key",
  "signing",
  "contract"
]);
const AIErrorExplanationSchema = z.object({
  /** Original error message from the Wallet API response */
  message: z.string(),
  /** Type/category of the error */
  type: AIErrorTypeSchema,
  /** AI-generated cause explanation */
  explanation: z.string(),
  /** AI-generated remediation steps */
  remediation: z.string()
});
const WalletCallEventErrorSchema = z.object({
  code: z.number().optional(),
  message: z.string().optional(),
  data: z.unknown().optional(),
  name: z.string().optional()
});
const WalletCallEventSchema = z.object({
  callId: z.string().optional(),
  method: WalletApiMethodSchema.optional(),
  status: z.enum([
    "error",
    "success"
  ]),
  timestamp: z.string(),
  network: z.string().optional(),
  appId: z.string().optional(),
  appName: z.string().optional(),
  durationMs: z.number().optional(),
  request: z.unknown(),
  response: z.unknown(),
  error: WalletCallEventErrorSchema.optional()
});
const CallIdGroupSummarySchema = z.object({
  callId: z.string(),
  appId: z.string().optional(),
  appName: z.string().optional(),
  network: z.string().optional(),
  status: CallIdGroupStatusSchema,
  timestamp: z.string()
});
const CallIdGroupDetailSchema = CallIdGroupSummarySchema.extend({
  events: z.array(WalletCallEventSchema)
});
export {
  AIErrorExplanationSchema,
  AIErrorTypeSchema,
  CallIdGroupDetailSchema,
  CallIdGroupStatusSchema,
  CallIdGroupSummarySchema,
  FAILED_PREPARE_CALL_ID_PREFIX,
  WalletApiMethodSchema,
  WalletCallEventErrorSchema,
  WalletCallEventSchema,
  WalletStatusCode
};
//# sourceMappingURL=wallet-api-logs.js.map